import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/admin/reports`;

const auth = token => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

/** Richer end-of-day summary: totals, GST split, discounts, voids, payment split. */
export const getEod = (reportDate, token) =>
  axios
    .get(`${API}/eod`, { ...auth(token), params: reportDate ? { report_date: reportDate } : {} })
    .then(r => r.data);

/** Revenue buckets. group_by is one of day | hour | category. */
export const getSales = ({ fromDate, toDate, groupBy = "day" } = {}, token) =>
  axios
    .get(`${API}/sales`, {
      ...auth(token),
      params: {
        ...(fromDate ? { from_date: fromDate } : {}),
        ...(toDate ? { to_date: toDate } : {}),
        group_by: groupBy,
      },
    })
    .then(r => r.data);

/** Per-day taxable value / CGST / SGST plus totals, over a range. */
export const getTaxes = ({ fromDate, toDate } = {}, token) =>
  axios
    .get(`${API}/taxes`, {
      ...auth(token),
      params: { ...(fromDate ? { from_date: fromDate } : {}), ...(toDate ? { to_date: toDate } : {}) },
    })
    .then(r => r.data);

export const getPayments = ({ fromDate, toDate } = {}, token) =>
  axios
    .get(`${API}/payments`, {
      ...auth(token),
      params: { ...(fromDate ? { from_date: fromDate } : {}), ...(toDate ? { to_date: toDate } : {}) },
    })
    .then(r => r.data);

/** Day-wise Sales report: bills, discounts, tax, tenders and cancellations for the range. */
export const getSalesReport = ({ fromDate, toDate } = {}, token) =>
  axios
    .get(`${API}/orders/sales-report`, {
      ...auth(token),
      params: { ...(fromDate ? { from_date: fromDate } : {}), ...(toDate ? { to_date: toDate } : {}) },
    })
    .then(r => r.data);
